import { Autocomplete, Box, FormControl, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { LangContext } from "../../contexts/LangContext";
import { api } from "../../services/api";
import SelectSys from "../selectSys";

export default function MultiSelectGroupN({ handleSelected, id, color, ...props }) {
  const [optionsSelect, setOptionsSelect] = useState([]);
  const { lang } = useContext(LangContext);

  useEffect(() => {
    getGroups();
  }, []);
  const getGroups = async () => {
    const { data: list } = await api({ method: "GET", url: "/source/client" });
    const listSelect = [];
    list.map((row) => {
      listSelect.push({ label: row.search_name, id: row.cre_id });
    });
    setOptionsSelect(listSelect);
  };
  return (
    <FormControl size="medium" sx={{ width: "100%" }}>
      {/* <SelectSys
        {...props}
        multiple
        title={lang.components.generic.select_group_label}
        options={optionsSelect}
        sx={{ width: "100%" }}
        onChange={(item, elemento) => {
          handleSelected(elemento);
        }}
        size="medium"
      /> */}
      <Box sx={{border: "1px solid #00a7e1", padding:"8px", borderRadius: "4px"}}>
        <Autocomplete
          multiple
          id="tags-readOnly"
          options={optionsSelect}
          onChange={(item, elemento) => {
            handleSelected(elemento);
          }}
          color={color}
          renderInput={(params) => (
            <TextField
              sx={{".css-dindiq-MuiInputBase-root-MuiInput-root:before": {
                border: "none"
              }, color: "#00a7e1"}}
              {...params}
              variant="standard"
              color={color}
            />
          )}
          {...props}
          sx={{
            width: { sm: "100%" },
            ".css-rugtdx-MuiButtonBase-root-MuiChip-root": {
              background: '#00a7e1',
              
          }
           }}
          renderOption={(props, option) => {
            return (
              <li {...props} style={{textTransform: "capitalize"}} key={option.id}>
                {option.label}
              </li>
            );
          }}
        />
      </Box>
    </FormControl>
  );
}
